export const EMoneyConditionType = {
  FixedValue: 0,

  Percentage: 1,
} as const

export type EMoneyConditionType = (typeof EMoneyConditionType)[keyof typeof EMoneyConditionType]
